import axios from 'axios';
import { toastr } from 'react-redux-toastr';

import { logout } from 'state/actions/auth';

// A 401 here means wrong credentials/OTP, not an expired session.
const isAuthEndpoint = (config) => (config?.url || '').includes('/auth/');

// A page mounts several requests at once, so one expired token produces many
// 401s. Only the first one logs out.
let handlingExpiredSession = false;

export const setupAuthInterceptor = (store) => {
  axios.interceptors.response.use(
    (response) => {
      // A request went through, so the token is valid again (fresh login).
      handlingExpiredSession = false;
      return response;
    },
    (error) => {
      const status = error && error.response && error.response.status;

      if (status === 401 && !isAuthEndpoint(error.config)) {
        if (!handlingExpiredSession) {
          handlingExpiredSession = true;
          toastr.error('', 'Your session has expired. Please sign in again.');
          // Clears auth.userData.id, which sends PrivateRoute to /login.
          store.dispatch(logout());
        }
      }

      return Promise.reject(error);
    }
  );
};
